                                                                    import { Button, Divider, Flex, Spinner, Text, VStack } from "@chakra-ui/react"
import GlucoseValues from "./GlucoseValues"
import { useGetGlucoseByRegistration } from "hooks/useGlucoseRegister"
import { useLazyQuery } from "@apollo/client"
import { GET_GLUCOSE_REPORT } from "queries/reportQueries"
import { downloadBinaryReport } from "functions/reports"
import { DownloadIcon } from "@phosphor-icons/react/dist/ssr"

interface Props {
    registration_number: string
    cpf: string
}

const Glucose = ({ registration_number, cpf }: Props) => {

    const { data, loading } = useGetGlucoseByRegistration(registration_number, cpf);
    const getGlucoseByRegistration = data?.getGlucose.glucose_monitoring || [];

    const [getReport, { loading: loadingReport }] = useLazyQuery(GET_GLUCOSE_REPORT, {
        fetchPolicy: 'no-cache'
    });

    const onDownload = async () => {
        const { data: reportData } = await getReport({
            variables: {
                registration_number,
                withDateLimit: false
            }
        });
        const report = reportData.getGlucoseReport;

        const filename = report.filename;
        const content = report.content;

        downloadBinaryReport(filename, content)
    }

    if (loading)
        return (<Flex w="full"><Spinner size="md" /></Flex>)

    return (
        <Flex w="full">
            <VStack gap={8} divider={<Divider />}>
                {
                    getGlucoseByRegistration.length == 0 ?
                        <Text fontSize="md">Não foram encontrados valores registrados</Text>
                        :
                        <>
                            <Text fontSize="md">Valores registrados</Text>
                            <Button colorScheme='green' onClick={onDownload} isLoading={loadingReport} leftIcon={<DownloadIcon weight="bold" />} > Exportar Dados</Button>
                            {
                                getGlucoseByRegistration.map((data: any) => <GlucoseValues {...data} />)
                            }
                        </>
                }
            </VStack>
        </Flex>
    )
}

export default Glucose